import { useRef } from 'react';
import { Modal } from 'src/components/baseComponents';
import { Button as AntButton } from 'antd';
import { CommonFormProps } from '.';
import { analytics } from 'src/services/analytics';
import { getAppointmentDetailsForAnalytics } from 'src/utils';

type Props = CommonFormProps;

export const LapPDVideoNorthwest = ({
  isOpen,
  appointment,
  form,
  onSave,
  loading,
}: Props) => {
  const formType = form?.form_type;
  const content = form?.content as { title: string; s3_url: string };
  const initialValues = {};

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleClick = async () => {
    analytics.track(
      'Clicked Continue In Html Video Form',
      getAppointmentDetailsForAnalytics(appointment!)
    );
    await onSave({ form_type: formType, response: {} });
    stopVideo();
  };

  const stopVideo = () => {
    if (iframeRef.current) {
      iframeRef.current.src = '';
    }
  };
  return (
    <div>
      {/** @ts-ignore */}
      <Modal
        open={isOpen}
        closable={false}
        className={'html-embedded-modal'}
        formClassName={''}
        initialValues={initialValues}
        submitButtonText=""
        cancelButtonText=""
        centered={true}
        customBody={
          <div className="">
            <div
              className="text-left font-semibold text-lg mb-6"
              style={{ fontFamily: 'Poppins' }}
            >
              {content?.title}
            </div>
            {/* <div className="border border-gray-400 mb-6"></div> */}
            <div
              className="shadow-xl"
              style={{
                padding: '57% 30% 0 0',
                position: 'relative',
              }}
            >
              <iframe
                ref={iframeRef}
                src={content?.s3_url}
                frameBorder="0"
                className="w-full h-full"
                allow="fullscreen; picture-in-picture; clipboard-write"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
              ></iframe>
            </div>
            <div
              className="text-left font-semibold text-lg mt-5 "
              style={{ fontFamily: 'Poppins' }}
            ></div>
            <div className="text-center mt-8">
              <AntButton
                disabled={loading}
                loading={loading}
                className="modal__form-footer__submit-button mt-10"
                onClick={handleClick}
              >
                Continue
              </AntButton>
            </div>
          </div>
        }
      />
    </div>
  );
};
